<template>
    <div class="layout-wrapper layout-navbar-full layout-horizontal layout-without-menu">
 
         <div class="layout-container">
             <NavBar />
             <!-- Layout container -->
             <div class="layout-page">
                 <!-- Content wrapper -->
                 <div class="content-wrapper">
                     
                     <!-- Menu -->
                     <MenuItem />
 
                     <!-- Content -->
                     <div class="container-xxl flex-grow-1 container-p-y">
 
                         <h4 class="fw-bold py-3 mb-4"><span class="text-muted fw-light">NSIA ASSURANCE /</span> Gestion natures Prospections</h4>
 
                         <!-- <Button 
                             type="button" class="mb-5" icon="pi pi-filter-slash" 
                             label="Ajouter une bande" outlined @click="clearFilter()" 
                         /> -->
                         <button style="text-transform: none;"
                             class="btn btn-label-primary waves-effect mb-3" 
                             @click="display=true,data.libelle_nature_prospection=''">
                             <i class="pi pi-plus"></i>&nbsp;
                             Ajouter une prospection
                         </button>
                         <DataTable 
                             v-model:filters="filters" :value="prospections" sortMode="multiple" paginator dataKey="id" :rows="10" 
                             :rowsPerPageOptions="[5,10, 30, 50, 100]"  tableStyle="min-width: 50rem" filterDisplay="menu" 
                             :globalFilterFields="['libelle_nature_prospection']"
                         >
                             <!-- paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                             currentPageReportTemplate="{first} to {last} of {totalRecords}" -->
                             
                             <template #header>
                                 <div class="flex justify-content-between">
 
                                     <!-- <Button 
                                         type="button" icon="pi pi-filter-slash" 
                                         label="Annuler la recherche" outlined 
                                         class="btn btn-label-primary waves-effect"
                                         @click="clearFilter()" 
                                     /> -->
                                     <button style="text-transform: none;"
                                         class="btn btn-label-primary waves-effect" 
                                         @click="clearFilter()" 
                                     >
                                         <i class="pi pi-filter-slash"></i>&nbsp;
                                         Annuler la recherche
                                     </button>
                                     <span class="p-input-icon-left">
                                         <i class="pi pi-search" />
                                         <InputText v-model="filters['global'].value" placeholder="Rechercher" />
                                     </span>
 
                                 </div>
                             </template>
 
                             <Column field="id" header="#" sortable style="width: 25%"></Column>
                             <Column field="libelle_nature_prospection" header="Libelle" sortable style="width: 25%"></Column>
                             <Column field="created_at" header="Creé le" sortable="" style="width: 25%">
                                 <template #body="slotProps">
                                     {{ new Date(slotProps.data.created_at).toLocaleDateString('fr-FR', options) }}
                                 </template>
                             </Column>
                             <Column field="updated_at" header="Modifié le" sortable="" style="width: 25%">
                                 <template #body="slotProps">
                                     {{ new Date(slotProps.data.updated_at).toLocaleDateString('fr-FR', options) }}
                                 </template>
                             </Column>
                             <Column headerStyle="width:4rem">
                                 <template #body="slotProps">
                                     <button type="button" 
                                         class="btn btn-label-primary waves-effect" 
                                         data-bs-toggle="dropdown" aria-expanded="false"
                                     >
                                         <i  class="pi pi-bars"/>
                                     </button>
                                     <ul class="dropdown-menu">
                                         <li>
                                             <a 
                                                 @click="showDonnees(slotProps.data)"
                                                 class="dropdown-item waves-effect" 
                                                 href="javascript:void(0);"
                                             >
                                                 Modifier
                                             </a>
                                         </li>
                                         <li>
                                             <a 
                                                 @click="deleteProspection(slotProps.data)"
                                                 class="dropdown-item waves-effect" 
                                                 href="javascript:void(0);"
                                             >
                                                 Supprimer 
                                             </a>
                                         </li>
                                     </ul>
                                     <!-- 
                                         @click="showDonnees(slotProps.data)" <SplitButton label="preferences" :model="items"  class="mb-2"></SplitButton> -->
                                 </template>
                             </Column>
 
                             <template #paginatorstart>
                                 <Button type="button" class="btn btn-label-primary waves-effect" icon="pi pi-refresh" text @click="getProspections" />
                             </template>
 
                             <template #paginatorend>
                                 <Button type="button" class="btn btn-label-primary waves-effect" icon="pi pi-download" text />
                             </template>
                         </DataTable>
                         
 
                     </div>
                 </div>
             </div>
         </div>
         <!-- Modal ajout ferme -->
         <Dialog v-model:visible="display" :style="{ width: '50vw' }"  modal header="Ajouter une prospection"  position="center">
                     <div class="container mt-4">
                         <form @submit="AddProspection($event)">
                         <div class="row">
                             <div class="col-12">
                                 <div class="form-floating form-floating-outline mb-4">
                                     <input type="text" class="form-control"  placeholder="Libelle" v-model="data.libelle_nature_prospection">
                                     <label for="basic-default-fullname">Libelle</label>
                                 </div>
                             </div>
                         </div>
                         <button type="submit" class="btn w-100 btn-primary waves-effect waves-light" :disabled="!data.libelle_nature_prospection">Enregistrer</button>
                     </form>
                     </div>
        </Dialog>
             <!-- Modal modification ferme -->
             <Dialog v-model:visible="display_edit" :style="{ width: '50vw' }" modal header="Modification"  position="center">
                <div class="container mt-4">
                         <form @submit="updateProspection($event)">
                         <div class="row">
                             <div class="col-12">
                                 <div class="form-floating form-floating-outline mb-4">
                                     <input type="text" class="form-control"  placeholder="Libelle" v-model="data.libelle_nature_prospection">
                                     <label for="basic-default-fullname">Libelle</label>
                                 </div>
                             </div>
                         </div>
                         <button type="submit" class="btn w-100 btn-secondary waves-effect waves-light" :disabled="!data.libelle_nature_prospection">Modifier</button>
                     </form>
                     </div>
             </Dialog>
    </div>
 </template>
 
 
 <script>
     // Import the CSS or use your own!
     import MenuItem from "@/components/MenuItem";
     import NavBar from "@/components/NavBar";
     
     // import { menu } from "@/assets/vendor/js/menu.js";
     import "vue-toastification/dist/index.css";
     import { useToast } from "vue-toastification";
     const toast = useToast();
     // import { VDataTable } from 'vuetify/labs/VDataTable';
     import { apiUrl } from "@/constants/config";
     import DataTable from 'primevue/datatable';
     import Column from 'primevue/column';
     import ColumnGroup from 'primevue/columngroup';   // optional
     import Row from 'primevue/row';                   // optional
     import Dialog from 'primevue/dialog';
     import Calendar from 'primevue/calendar';
     import { FilterMatchMode, FilterOperator } from 'primevue/api';
 
     export default{
         name : 'NatureProspections',
         components : {
             NavBar, MenuItem,
             // VDataTable, 
             DataTable, Column, ColumnGroup, Row,
             //modal
             Dialog
         },
         data() {
             return {
                 data : {libelle_nature_prospection : '', id:''},
                 prospections : [],
                 options : { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
                 search: '',
                 consommations: [], 
                 filters: null,
                 display : false,
                 display_edit : false,
             }
         },
 
         created(){
             this.initFilters()
         },
         mounted(){
             this.getProspections()
         },
         methods : {
            async getProspections()
            {
                const response = await this.$axios.get('prospection/all')
                this.prospections = [...response.data.data]
            },
             async AddProspection(e){
                 e.preventDefault();
                    let datas = new FormData()
                    datas.append('libelle', this.data.libelle_nature_prospection)
                    let response = await this.$axios.post('prospection/add', datas);
                     console.log(response);
                     if(response.data.code ==400){
                         toast.error(response.data.message)
                         return
                     }
                     toast.success(response.data.message)
                     this.data.libelle_nature_prospection = ''
                     this.display = false
                     this.getProspections()
             },
             async updateProspection(e){
                    e.preventDefault();
                    let datas = new FormData()
                    datas.append('id', this.data.id)
                    datas.append('libelle', this.data.libelle_nature_prospection)

                    let response = await this.$axios.post(`prospection/update`, datas);
                       
                     if(response.data.code ==400){
                         toast.error(response.data.message)
                         return
                     }
                     toast.success(response.data.message)
                     
                     this.display_edit = false
                     this.getProspections()
 
             },
             async deleteProspection(datas){
                const data = new FormData()
                data.append('id', datas.id)
                this.$swal({
                    title: 'NSIA VIE',
                    text: "Voulez supprimer la prospection",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Supprimer',
                    cancelButtonText: 'Annuler'
                    }).then(async (result)=>{
                        if(result.isConfirmed){
                            const response = await this.$axios.post(`prospection/delete`, data)
                            if(response.code){
                                toast.error(response.data.message)
                                return
                            } else{
                                toast.success(response.data.message)
                                this.getProspections()
                            }
                        }
                    })
                        
            },
             clearFilter() {
                 this.initFilters();
             },
 
             initFilters() {
                 this.filters = {
                     global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                     reference: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                 };
             },
             showDonnees(donnees){
                 this.data.libelle_nature_prospection = donnees.libelle_nature_prospection
                 this.data.id = donnees.id
                 this.display_edit = true
             },
             resetDatas(){
                 this.datas.quantite = ''
                 this.datas.aliment_id = ''
                 this.datas.bande_id = ''
             }
         },
 
 
 
     }
 
 </script>
 
 <style>
 
 </style>